import { useRouter } from "next/router";
import { useEffect } from "react";

import * as gtag from "./Functions";

const GoogleAnalytics = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      gtag.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return <></>;
};

const Analytics = () => {
  return <GoogleAnalytics />;
};

export default Analytics;
